import { defineComponent as _defineComponent } from 'vue'
import { EnumIroType, type IroSectionLinkType } from '~/types/types'

export default /*#__PURE__*/_defineComponent({
  __name: 'IroCell',
  props: {
  item: {
    type: Object as PropType<IroSectionLinkType>,
    required: true,
  },
  type: {
    type: String as PropType<EnumIroType>,
    required: true,
    validator: (value: EnumIroType) =>
      [
        EnumIroType.PositiveImpact,
        EnumIroType.NegativeImpact,
        EnumIroType.Risk,
        EnumIroType.Opportunity,
      ].includes(value),
  },
},
  setup(__props) {



const getTypeLabel = (iType: string) => {
  switch (iType) {
    case EnumIroType.PositiveImpact:
      return 'positive impacts'
    case EnumIroType.NegativeImpact:
      return 'negative impacts'
    case EnumIroType.Risk:
      return 'risks'
    case EnumIroType.Opportunity:
      return 'opportunities'
    default:
      return ''
  }
}

const parseIros = (iroLinks: any, iType: string) => {
  if (!iroLinks) {
    return {
      visibleNames: [],
      hiddenNames: [],
      hiddenCount: 0,
    }
  }
  const iros = iroLinks.filter((iroLink: any) => iroLink.iro.type === iType)
  const visibleIros = iros.slice(0, 3)
  const hiddenCount = iros.length - visibleIros.length
  return {
    visibleNames: visibleIros,
    hiddenNames: iros.slice(3),
    hiddenCount,
  }
}

return { __sfc: true,getTypeLabel, parseIros }
}

})